
import {
    Alert,
    Avatar,
    Box,
    Button,
    Card,
    CardContent,
    Chip,
    Divider,
    Grid,
    MenuItem,
    Stack,
    TextField,
    Typography,
} from "@mui/material";

import Timeline from "@mui/lab/Timeline";
import TimelineItem from "@mui/lab/TimelineItem";
import TimelineSeparator from "@mui/lab/TimelineSeparator";
import TimelineConnector from "@mui/lab/TimelineConnector";
import TimelineContent from "@mui/lab/TimelineContent";
import TimelineDot from "@mui/lab/TimelineDot";

import {
    AssignmentTurnedIn,
    Autorenew,
    Business,
    CheckCircle,
    Description,
    Email,
    ForwardToInbox,
    Person,
    Phone,
    Reply,
} from "@mui/icons-material";

import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";

import api from "../../services/api";
import Date from "../../utils/date";
import Loading from "../../load/loading";
import HeaderSession from "../../utils/headerSession";
import TextoFormatado from "../../utils/textoFormatado";
import ResponseReclamacao from "./responseReclamacao";
import LoadingShort from "../../load/loadingShort";

export default function ViewReclamacao() {

    const { id } = useParams();
    const user = useSelector((state) => state.account.user);
    const [reclamacao, setReclamacao] = useState(null);
    const [loading, setLoading] = useState(true);
    const [loadEncaminhar, setLoadEncaminhar] = useState('');
    const [refresh, setRefresh] = useState(false);
    const [departamento, setDepartamento] = useState("");
    const [estado, setEstado] = useState("");
    const [success, setSuccess] = useState("");
    const [error, setError] = useState("");

    const departamentos = [
        "DGA SE",
        "DGS SA",
        "DCITMS",
        "DADG",
        "DASG",
        "DCQMTS",
        "DFTEC",
        "DLIF",
        "DMTS",
    ];

    const estados = [
        "Análise",
        "Encaminhado",
        "Respondido",
        "Concluído",
    ];

    useEffect(() => {
        buscarReclamacao();
    }, [id, refresh]);

    const buscarReclamacao = async () => {

        try {

            setLoading(true);

            const response = await api.get(`/reclamacao/${id}`);

            setReclamacao(response?.data?.reclamacao);

        } catch (err) {

            console.error(err);

        } finally {

            setLoading(false);
        }
    };

    const handleEncaminhar = async () => {
        try {
            setLoadEncaminhar('encaminhando');
            setError("");
            setSuccess("");

            await api.patch("/reclamacao/change-status", {
                id,
                status: "Encaminhado",
                departamento,
                userId: user?._id,
            });

            setSuccess("Processo encaminhado com sucesso.");

            setDepartamento("");

            setRefresh((prev) => !prev);
            setLoadEncaminhar('');
        } catch (err) {
            // console.log(err);
            setLoadEncaminhar('');
            setError(err.response.data.message || "Erro ao encaminhar processo.");
        }
    };

    const handleChangeEstado = async () => {

        try {
            setLoadEncaminhar('alterando');
            setError("");
            setSuccess("");

            await api.patch("/reclamacao/change-status", {
                id,
                status: estado,
                userId: user?._id,
            });

            setSuccess("Estado atualizado com sucesso.");

            setEstado("");

            setRefresh((prev) => !prev);
            setLoadEncaminhar('');
        } catch (err) {
            setLoadEncaminhar('');

            setError(err.response.data.message || "Erro ao atualizar estado.");
        }
    };

    const getStatusColor = (status) => {

        switch (status) {

            case "Concluído":
                return "success";

            case "Respondido":
                return "info";

            case "Encaminhado":
                return "warning";

            default:
                return "default";
        }
    };

    if (loading) {
        return <Loading text="A carregar processo..." />;
    }

    return (
        <Box pb={5}>

            <HeaderSession title={`GESTÃO DE ${reclamacao?.tipo ? reclamacao?.tipo : 'RECLAMAÇÃO'}`} />

            <Grid container spacing={3}>

                {/* LADO ESQUERDO */}
                <Grid item xs={12} lg={8}>

                    {/* DADOS */}
                    <Card
                        elevation={3}
                        sx={{
                            borderRadius: 1,
                        }}
                    >

                        <CardContent>

                            <Stack
                                direction="row"
                                justifyContent="space-between"
                                alignItems="center"
                                mb={3}
                                flexWrap="wrap"
                                gap={2}
                            >

                                <Box>

                                    <Typography
                                        variant="h5"
                                        fontWeight="bold"
                                    >
                                        {reclamacao?.assunto}
                                    </Typography>

                                    <Typography
                                        color="text.secondary"
                                    >
                                        Processo Nº {reclamacao?.numero}
                                    </Typography>

                                </Box>

                                <Chip
                                    label={reclamacao?.status}
                                    color={getStatusColor(
                                        reclamacao?.status
                                    )}
                                    sx={{
                                        fontWeight: "bold",
                                        px: 1,
                                    }}
                                />

                            </Stack>

                            <Divider sx={{ mb: 3 }} />

                            <Grid container spacing={3}>

                                <Grid item xs={12} md={6}>
                                    <Stack
                                        direction="row"
                                        spacing={2}
                                        alignItems="center"
                                    >
                                        <Avatar>
                                            <Person />
                                        </Avatar>

                                        <Box>
                                            <Typography
                                                variant="body2"
                                                color="text.secondary"
                                            >
                                                Nome
                                            </Typography>

                                            <Typography fontWeight="600">
                                                {reclamacao?.nome}
                                            </Typography>
                                        </Box>
                                    </Stack>
                                </Grid>

                                <Grid item xs={12} md={6}>
                                    <Stack
                                        direction="row"
                                        spacing={2}
                                        alignItems="center"
                                    >
                                        <Avatar>
                                            <Phone />
                                        </Avatar>

                                        <Box>
                                            <Typography
                                                variant="body2"
                                                color="text.secondary"
                                            >
                                                Telefone
                                            </Typography>

                                            <Typography fontWeight="600">
                                                {reclamacao?.tel1}
                                            </Typography>
                                        </Box>
                                    </Stack>
                                </Grid>

                                <Grid item xs={12} md={6}>
                                    <Stack
                                        direction="row"
                                        spacing={2}
                                        alignItems="center"
                                    >
                                        <Avatar>
                                            <Email />
                                        </Avatar>

                                        <Box>
                                            <Typography
                                                variant="body2"
                                                color="text.secondary"
                                            >
                                                Email
                                            </Typography>

                                            <Typography fontWeight="600">
                                                {reclamacao?.email || "N/A"}
                                            </Typography>
                                        </Box>
                                    </Stack>
                                </Grid>

                                <Grid item xs={12} md={6}>
                                    <Stack
                                        direction="row"
                                        spacing={2}
                                        alignItems="center"
                                    >
                                        <Avatar>
                                            <Description />
                                        </Avatar>

                                        <Box>
                                            <Typography
                                                variant="body2"
                                                color="text.secondary"
                                            >
                                                Data
                                            </Typography>

                                            <Typography fontWeight="600">
                                                <Date
                                                    date={reclamacao?.createdAt}
                                                />
                                            </Typography>
                                        </Box>
                                    </Stack>
                                </Grid>

                            </Grid>

                            {/* DESCRIÇÃO */}
                            <Box
                                sx={{
                                    mt: 4,
                                    p: 3,
                                    borderRadius: 1,
                                    background: "#f7f7f7",
                                }}
                            >

                                <Typography
                                    variant="h6"
                                    fontWeight="bold"
                                    mb={2}
                                >
                                    Exposição
                                </Typography>

                                <TextoFormatado
                                    texto={reclamacao?.descricao}
                                />

                            </Box>

                            {/* ANEXO */}
                            {reclamacao?.anexo1 && (

                                <Box mt={4}>

                                    <Typography
                                        variant="h6"
                                        fontWeight="bold"
                                        mb={2}
                                    >
                                        Documento Anexado
                                    </Typography>

                                    <embed
                                        src={reclamacao?.anexo1}
                                        width="100%"
                                        height="700px"
                                        style={{
                                            border: "1px solid #ddd",
                                            borderRadius: 12,
                                        }}
                                    />

                                </Box>
                            )}

                        </CardContent>

                    </Card>

                    {/* RESPOSTAS */}
                    <ResponseReclamacao
                        userId={user?._id}
                        id={id}
                        respostas={reclamacao?.respostas}
                        setUpdate={setRefresh}
                    />

                </Grid>

                {/* LADO DIREITO */}
                <Grid item xs={12} lg={4}>

                          {/* TIMELINE */}
                          <Card
                        elevation={3}
                        sx={{
                            borderRadius: 1,
                            mb: 3,
                        }}
                    >

                        <CardContent>

                            <Typography
                                variant="h6"
                                fontWeight="bold"
                                mb={2}
                            >
                                Histórico do Processo
                            </Typography>

                            <Timeline position="right" >

                                <TimelineItem>

                                    <TimelineSeparator>
                                        <TimelineDot color="primary">
                                            <AssignmentTurnedIn />
                                        </TimelineDot>

                                        <TimelineConnector />
                                    </TimelineSeparator>

                                    <TimelineContent>

                                        <Typography fontWeight="bold">
                                            Processo Criado
                                        </Typography>

                                        <Typography
                                            variant="body2"
                                            color="text.secondary"
                                        >
                                            <Date
                                                date={reclamacao?.createdAt}
                                            />
                                        </Typography>

                                    </TimelineContent>

                                </TimelineItem>

                                {reclamacao?.status === "Encaminhado" && (

                                    <TimelineItem>

                                        <TimelineSeparator>
                                            <TimelineDot color="warning">
                                                <Business />
                                            </TimelineDot>

                                            <TimelineConnector />
                                        </TimelineSeparator>

                                        <TimelineContent>

                                            <Typography fontWeight="bold">
                                                Processo Encaminhado
                                            </Typography>

                                            <Typography
                                                variant="body2"
                                                color="text.secondary"
                                            >
                                                Departamento:
                                                {" "}
                                                {reclamacao?.departamento ||
                                                    "N/A"}
                                            </Typography>

                                            <Typography
                                                variant="body2"
                                                color="text.secondary"
                                            >
                                                <Date
                                                    date={reclamacao?.updatedAt}
                                                />
                                            </Typography>

                                        </TimelineContent>

                                    </TimelineItem>
                                )}

                                {reclamacao?.status === "Respondido" && (

                                    <TimelineItem>

                                        <TimelineSeparator>
                                            <TimelineDot color="info">
                                                <Reply />
                                            </TimelineDot>

                                            <TimelineConnector />
                                        </TimelineSeparator>

                                        <TimelineContent>

                                            <Typography fontWeight="bold">
                                                Processo Respondido
                                            </Typography>


                                            <Typography
                                                variant="body2"
                                                color="text.secondary"
                                            >
                                                <Date
                                                    date={reclamacao?.updatedAt}
                                                />
                                            </Typography>
                                        </TimelineContent>

                                    </TimelineItem>
                                )}

                                {reclamacao?.status === "Concluído" && (

                                    <TimelineItem>

                                        <TimelineSeparator>
                                            <TimelineDot color="success">
                                                <CheckCircle />
                                            </TimelineDot>
                                        </TimelineSeparator>

                                        <TimelineContent>

                                            <Typography fontWeight="bold">
                                                Processo Finalizado
                                            </Typography>


                                            <Typography
                                                variant="body2"
                                                color="text.secondary"
                                            >
                                                <Date
                                                    date={reclamacao?.updatedAt}
                                                />
                                            </Typography>
                                        </TimelineContent>

                                    </TimelineItem>
                                )}

                            </Timeline>

                        </CardContent>

                    </Card>

                    {/* AÇÕES */}
                    <Card
                        elevation={3}
                        sx={{
                            borderRadius: 1,
                            mb: 3,
                            position: "sticky",
                            top: 20,
                        }}
                    >

                        <CardContent>

                            <Typography
                                variant="h6"
                                fontWeight="bold"
                                mb={3}
                            >
                                Gestão do Processo
                            </Typography>

                            {success && (
                                <Alert
                                    severity="success"
                                    sx={{ mb: 2 }}
                                >
                                    {success}
                                </Alert>
                            )}

                            {error && (
                                <Alert
                                    severity="error"
                                    sx={{ mb: 2 }}
                                >
                                    {error}
                                </Alert>
                            )}

                            {/* ENCAMINHAR */}
                            <Typography
                                fontWeight="bold"
                                mb={1}
                            >
                                Encaminhar Processo
                            </Typography>

                            <TextField
                                select
                                fullWidth
                                size="small"
                                label="Departamento"
                                value={departamento}
                                onChange={(e) =>
                                    setDepartamento(e.target.value)
                                }
                                sx={{ mb: 2 }}
                            >
                                {departamentos.map((item) => (
                                    <MenuItem
                                        key={item}
                                        value={item}
                                    >
                                        {item}
                                    </MenuItem>
                                ))}
                            </TextField>

                            <Button
                                fullWidth
                                variant="contained"
                                startIcon={<ForwardToInbox />}
                                disabled={!departamento}
                                onClick={handleEncaminhar}
                                color="secondary"
                                sx={{
                                    mb: 4,
                                    py: 1.3,
                                    borderRadius: 1,
                                }}
                            >
                            {loadEncaminhar === 'encaminhando' ? <LoadingShort /> : 'Encaminhar'}
                                
                            </Button>

                            {/* ALTERAR ESTADO */}
                            <Typography
                                fontWeight="bold"
                                mb={1}
                            >
                                Alterar Estado
                            </Typography>

                            <TextField
                                select
                                fullWidth
                                size="small"
                                label="Estado"
                                value={estado}
                                onChange={(e) =>
                                    setEstado(e.target.value)
                                }
                                sx={{ mb: 2 }}
                            >
                                {estados.map((item) => (
                                    <MenuItem
                                        key={item}
                                        value={item}
                                    >
                                        {item}
                                    </MenuItem>
                                ))}
                            </TextField>

                            <Button
                                fullWidth
                                variant="outlined"
                                startIcon={<Autorenew />}
                                disabled={!estado}
                                onClick={handleChangeEstado}
                                sx={{
                                    py: 1.3,
                                    borderRadius: 3,
                                }}
                            >
                                {loadEncaminhar === 'alterando' ? <LoadingShort /> : 'Atualizar Estado'}
                            </Button>

                        </CardContent>
                    </Card>

          

                </Grid>

            </Grid>

        </Box>
    );
}